import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import { SET_OVERLAY_DISPLAY } from '@/store/constants/mutation-types';
@Module({ namespaced: true, name: 'MarkersFilteringModule' })
export default class MarkersFilteringModule extends VuexModule {
  public overlayEnable = false;

  @Mutation
  public [SET_OVERLAY_DISPLAY](value: boolean) {
    this.overlayEnable = value;
  }
}
